import { Stack, TextField } from '@mui/material';

import { useDebouncedBlockContent } from '@/hooks/use-debounced-block-content';
import type { HeroBlockContent } from '@/types/database';

export function HeroBlockEditPanel({
  content,
  onUpdate,
}: {
  content: HeroBlockContent;
  onUpdate: (content: HeroBlockContent) => void;
}) {
  const [draft, update] = useDebouncedBlockContent(content || { headline: '' }, onUpdate);

  return (
    <Stack spacing={1.5}>
      <TextField
        label="Headline"
        value={draft.headline || ''}
        onChange={(event) => update({ ...draft, headline: event.target.value })}
        fullWidth
      />
      <TextField
        label="Subheadline"
        value={draft.subheadline || ''}
        onChange={(event) => update({ ...draft, subheadline: event.target.value })}
        fullWidth
      />
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5}>
        <TextField
          label="Button Text"
          value={draft.buttonText || ''}
          onChange={(event) => update({ ...draft, buttonText: event.target.value })}
          fullWidth
        />
        <TextField
          label="Button Link"
          value={draft.buttonLink || ''}
          onChange={(event) => update({ ...draft, buttonLink: event.target.value })}
          fullWidth
        />
      </Stack>
    </Stack>
  );
}
